export const FETCH_CAMPAIGN_TEMPLATES_REQUESTED = "FETCH_CAMPAIGN_TEMPLATES_REQUESTED";
export const FETCH_CAMPAIGN_TEMPLATES_SUCCESS = "FETCH_CAMPAIGN_TEMPLATES_SUCCESS";
export const FETCH_CAMPAIGN_TEMPLATES_FAIL = "FETCH_CAMPAIGN_TEMPLATES_FAIL";

export const ADD_CAMPAIGN_TEMPLATE_REQUESTED = "ADD_CAMPAIGN_TEMPLATE_REQUESTED";
export const ADD_CAMPAIGN_TEMPLATE_SUCCESS = "ADD_CAMPAIGN_TEMPLATE_SUCCESS";
export const ADD_CAMPAIGN_TEMPLATE_FAIL = "ADD_CAMPAIGN_TEMPLATE_FAIL";
export const ADD_CAMPAIGN_TEMPLATE_CLEAR = "ADD_CAMPAIGN_TEMPLATE_CLEAR";

export const DELETE_CAMPAIGN_TEMPLATE_REQUESTED = "DELETE_CAMPAIGN_TEMPLATE_REQUESTED";
export const DELETE_CAMPAIGN_TEMPLATE_SUCCESS = "DELETE_CAMPAIGN_TEMPLATE_SUCCESS";
export const DELETE_CAMPAIGN_TEMPLATE_FAIL = "DELETE_CAMPAIGN_TEMPLATE_FAIL";

export const EDIT_CAMPAIGN_TEMPLATE_REQUESTED = "EDIT_CAMPAIGN_TEMPLATE_REQUESTED";
export const EDIT_CAMPAIGN_TEMPLATE_SUCCESS = "EDIT_CAMPAIGN_TEMPLATE_SUCCESS";
export const EDIT_CAMPAIGN_TEMPLATE_FAIL = "EDIT_CAMPAIGN_TEMPLATE_FAIL";
export const EDIT_CAMPAIGN_TEMPLATE_CLEAR = "EDIT_CAMPAIGN_TEMPLATE_CLEAR";

export const FETCH_CAMPAIGN_TEMPLATE_HTML_REQUESTED = "FETCH_CAMPAIGN_TEMPLATE_HTML_REQUESTED";
export const FETCH_CAMPAIGN_TEMPLATE_HTML_SUCCESS = "FETCH_CAMPAIGN_TEMPLATE_HTML_SUCCESS";
export const FETCH_CAMPAIGN_TEMPLATE_HTML_FAIL = "FETCH_CAMPAIGN_TEMPLATE_HTML_FAIL";